const packages = document.querySelectorAll('.linked-package-teaser');

if (packages.length > 0) {
    packages.forEach(p => {
        p.addEventListener('click', () => {
            const link = p.querySelector('a');
            if (link.href) {
                window.location.href = link.href;
            }
        });
    });
}
